import React from 'react';
import { ClosureNotice } from './pages/ClosureNotice';
export function App() {
  return <ClosureNotice data-id="element-0" />;
}